var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm.message
        ? _c(
            "v-alert",
            {
              staticStyle: {
                "margin-top": "50px",
                "margin-left": "50%",
                left: "-10%",
              },
              attrs: { type: "error", width: "20%" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0 mx-3" },
                [
                  _c(
                    "v-tabs",
                    {
                      staticClass: "no-transition",
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        "v-tab",
                        {
                          key: "tab-c-l",
                          attrs: { disabled: !_vm.ifCanViewDrafts() },
                          on: {
                            click: function ($event) {
                              return _vm.updateActiveTab(1)
                            },
                          },
                        },
                        [
                          _vm._v("Draft "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "20" },
                            },
                            [_vm._v("mdi-alert-rhombus-outline")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab",
                        {
                          key: "tab-c-pre-release",
                          attrs: { disabled: !_vm.ifCanViewActive() },
                          on: {
                            click: function ($event) {
                              return _vm.updateActiveTab(2)
                            },
                          },
                        },
                        [
                          _vm._v("Active "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { size: "20" },
                            },
                            [_vm._v("mdi-flower-outline")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0 mx-3 mt-2" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { width: "100%", elevation: "0" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { width: "100%", elevation: "0" },
                            },
                            [
                              _c(
                                "v-tabs-items",
                                {
                                  staticClass: "mt-0",
                                  model: {
                                    value: _vm.tab,
                                    callback: function ($$v) {
                                      _vm.tab = $$v
                                    },
                                    expression: "tab",
                                  },
                                },
                                [
                                  _c(
                                    "v-tab-item",
                                    {
                                      key: "v-packages-drafts-list",
                                      attrs: {
                                        transition: "fade-transition",
                                        "reverse-transition": "fade-transition",
                                      },
                                    },
                                    [
                                      _c("v-packages-drafts-list", {
                                        ref: "v-packages-drafts-list",
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tab-item",
                                    {
                                      key: "v-packages-active-list",
                                      attrs: {
                                        transition: "fade-transition",
                                        "reverse-transition": "fade-transition",
                                      },
                                    },
                                    [
                                      _c("v-packages-active-list", {
                                        ref: "v-packages-active-list",
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }